import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NavbarComponent } from './navbar.component';
import { MatButtonModule, MatDialogModule } from '@angular/material';
import { SincronizacaoComponent } from './sincronizacao/sincronizacao.component';
@NgModule({
    imports: [ RouterModule, CommonModule, MatButtonModule, MatDialogModule ],
    declarations: [ NavbarComponent, SincronizacaoComponent ],
    exports: [ NavbarComponent ],
    entryComponents:[SincronizacaoComponent]
})

export class NavbarModule {}
